<ycn-agent-tasks
        [visibleTasks]="visibleTasks()"
        [completedTasks]="completedTasks()"
        [inProgressTasks]="inProgressTasks()"
        [cancelledTasks]="cancelledTasks()"
        [completionPercentage]="taskCompletionPercentage()"
        [hasInProgressTasks]="hasInProgressTasks()"
        (deleteTask)="onDeleteTask($event)"
        (hideTask)="onHideTask($event)"
        (taskSelected)="onTaskSelected($event)"
/>

<div class="side-panel-content flex-auto min-height-0 d-flex flex-column"
     [class.bg-side-panel-ai]="isWelcomeScreen()"
     [class.yc-blue-to-panel]="!isWelcomeScreen()">
    <div class="flex-auto min-height-0 relative">
        <div #scrollContainer class="page-ai-scroll z-1 pt-4 pl-20 pr-20">
            @if (isWelcomeScreen()) {
                <div class="height-full min-height-200 d-flex flex-column justify-content-center text-center">
                    <div class="mb-6">
                        <div class="side-panel-empty-state mb-1">Hello, {{ user.firstName }}.</div>
                        <div class="side-panel-empty-subtitle">How can I help you today?</div>
                    </div>
                    <div class="side-panel-empty-text pt-2">Not sure?
                        <div class="text-normal">Ask me what I can do.</div>
                    </div>
                    <ycn-agent-suggested-prompts class="d-block mt-5 pt-20 text-left"
                                                 source="side_panel"
                                                 (promptSelected)="onSuggestedPromptSelected($event)" />
                </div>
            } @else if (isChatScreen()) {
                <div #scrollContent>
                    @for (message of currentMessages(); track $index) {
                        @if (message.role === 'user') {
                            <ycn-agent-user-message [messageText]="message.text" [files]="message.files" />
                        } @else if (message.role === 'assistant') {
                            @if (message.steps?.length) {
                                <ycn-agent-steps [steps]="message.steps!"
                                                 [turnComplete]="!chatState().isStreaming || !$last"
                                                 [expanded]="stepsExpanded()"
                                                 (toggled)="onStepsToggled($event)" />
                            }
                            @if (message.text) {
                                <ycn-agent-response-message [messageText]="message.text"
                                                            [displayActions]="message.displayActions ?? []"
                                                            [displayAsCard]="true"
                                                            (deleteChat)="openDeleteChatModal()" />
                            }
                        }
                    }

                    @if (currentTaskSteps()?.length) {
                        <ycn-agent-steps [steps]="currentTaskSteps()!" [streaming]="true"
                                         [expanded]="stepsExpanded()"
                                         (toggled)="onStepsToggled($event)" />
                    }

                    @if (currentToolCallToConfirm(); as toolCall) {
                        <ycn-agent-tool-permission-box
                            [toolCall]="toolCall"
                            (confirm)="onToolPermissionConfirm($event)"
                        />
                    } @else if (isLoading()) {
                        <ycn-agent-loader [currentLoadingText]="currentLoadingText()" />
                    } @else if (showIdleIcon()) {
                        <div class="section-ai-response-mark">
                                <img ycnImage [imageSrc]="'images/core/ycharts-logo-ai-circle.svg'" class="width-24 height-24" alt="">
                        </div>
                    }

                    @for (queued of queuedMessagesForDisplay(); track $index) {
                        <div style="opacity: 0.5;">
                            <ycn-agent-user-message [messageText]="queued.text" [files]="queued.files" />
                        </div>
                    }
                </div>
            }
        </div>
        @if (showScrollDownButton()) {
            <div class="page-ai page-ai-scroll-footer text-center" style="z-index: 100;">
                <button class="btn btn-support btn-outline btn-ghost btn-scroll"
                        (click)="scrollToBottom()">
                    Scroll Down
                </button>
            </div>
        }
    </div>

     <!-- User input -->
    <ycn-agent-user-input
        class="flex-none z-1 pt-20 pl-20 pr-20 pb-4"
        [maxAudioCanvasWidth]="maxAudioCanvasWidth()"
        [showNewChatButton]="true"
        [compactLayout]="true"
        [modelOptions]="modelOptions()"
        [selectedModelId]="selectedModelId()"
        [modelLocked]="isChatScreen()"
        (modelChange)="onModelChange($event)"
        (openNewChat)="openNewChat()"
        (sendMessage)="sendMessage($event)"
    />

    <ycn-confirm-modal
        #deleteChatModal
        confirmHeader="Delete Chat"
        confirmText="Deleting the chat will remove it from your chat history, including files uploaded and downloaded. Are you sure you want to delete?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        [confirmButtonClasses]="'btn-danger'"
        modalTestId="delete-agent-chat"
        (confirmHandler)="onDeleteChatConfirmed($event)"
    />
</div>
